// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2L2Hl","errorLogs":"styles_errorLogs__1qMc0"};